import {LABELS} from '../constants/labels'

export function blockedCommentingReason(isRepoArchived: boolean, isReferenceLocked: boolean) {
  return isRepoArchived
    ? LABELS.repoArchived
    : isReferenceLocked
      ? LABELS.issueLockedToCollaborators
      : LABELS.canNotCommentOnIssue
}
